import { render, staticRenderFns } from "./compare_product_results.vue?vue&type=template&id=133cfd6e&scoped=true"
import script from "./compare_product_results.vue?vue&type=script&lang=js"
export * from "./compare_product_results.vue?vue&type=script&lang=js"
import style0 from "./compare_product_results.vue?vue&type=style&index=0&id=133cfd6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133cfd6e",
  null
  
)

export default component.exports